function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { sendDataLayerMoreEvent } from './utils';
var FixedDeviceComponent = function FixedDeviceComponent(_ref) {
  var objectMoreData = _ref.objectMoreData,
    mobileFlag = _ref.mobileFlag;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    mobileBox = _useState2[0],
    toggleMobileBox = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    leftPosition = _useState4[0],
    setLeftPosition = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    deviceImgWidth = _useState6[0],
    setDeviceImgWidth = _useState6[1];
  var triggerMobileBox = function triggerMobileBox(e) {
    if (mobileFlag) {
      sendDataLayerMoreEvent('All link & Button Clicks', "CTA tab mobile ".concat(mobileBox ? 'close' : 'open'), 'no action');
      toggleMobileBox(!mobileBox);
    }
  };
  var clickHandle = function clickHandle(e, whichButtons) {
    if (whichButtons) {
      var isMobile = window.innerWidth < 991;
      var currentClass = !isMobile ? window.location.href.split('?')[1] : '';
      var url = e.currentTarget.getAttribute('href');
      sendDataLayerMoreEvent('All link & Button Clicks', whichButtons, currentClass ? "".concat(currentClass, " > ").concat(url) : "mobile > ".concat(url), e);
    }
  };
  var addDataAttributes = function addDataAttributes($element) {
    var buttonsName = ['Explore features', 'Get in touch'];
    try {
      if ($element && !$element.classList.contains('event-initialized')) {
        $element.classList.add('event-initialized');
        $element.querySelectorAll('a:not(.event-initialized)').forEach(function ($el, index) {
          $el.classList.add('event-initialized');
          var whichButtons = buttonsName[index] ? buttonsName[index] : 'Button clicked';
          $el.addEventListener('click', function (e) {
            return clickHandle(e, whichButtons);
          });
        });
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(function () {
    //waiting for animation
    setTimeout(function () {
      var $mainImg = document.querySelector('.scroll-wrapper .section-image img');
      var $deviceImg = document.querySelector('.fixed-device__container img');
      var deviceWidth = $deviceImg ? $deviceImg.offsetWidth : 220;
      var imgWidth = $mainImg ? $mainImg.offsetWidth : null;
      setDeviceImgWidth(deviceWidth);
      setLeftPosition(imgWidth);
    }, 1000);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "fixed-device " + (mobileBox ? 'active' : ''),
    onClick: !mobileBox ? triggerMobileBox : null,
    style: {
      left: leftPosition && leftPosition < window.innerWidth - 400 ? leftPosition - deviceImgWidth / 2 : '64%'
    }
  }, !mobileBox && /*#__PURE__*/React.createElement("div", {
    className: "learn-more"
  }, /*#__PURE__*/React.createElement("span", {
    className: "plus"
  }, "\uE612"), objectMoreData.learnMore && objectMoreData.learnMore.link && /*#__PURE__*/React.createElement("span", null, objectMoreData.learnMore.link.content)), /*#__PURE__*/React.createElement("div", {
    className: "fixed-device__container"
  }, mobileBox && /*#__PURE__*/React.createElement("div", {
    className: "close-circle",
    onClick: triggerMobileBox
  }, "\uEAD7"), /*#__PURE__*/React.createElement("img", {
    src: objectMoreData.deviceImage.image.src,
    alt: objectMoreData.deviceImage.image.alt,
    className: "fixed-img"
  }), /*#__PURE__*/React.createElement("div", {
    className: "fixed-device__container__description " + (mobileBox ? 'active' : ''),
    dangerouslySetInnerHTML: {
      __html: objectMoreData.deviceDescription.html.html
    },
    ref: addDataAttributes
  })));
};
export default FixedDeviceComponent;